/**
 * Vite 進入點。
 *
 * **CSS 引入順序是刻意的，不要調換**
 *
 * 1. **@mobile/theme**：Ionic 官方基礎樣式（收進 `ionic` cascade layer）+
 *    `@theme` token 到 `--ion-*` 的映射。**必須在 ui-system 之前**——layer 的
 *    優先順序由首次宣告位置決定，晚於 Tailwind 宣告的話，Ionic 反而會蓋掉
 *    utility（例如 `button { border-radius: 0 }` 會蓋掉 `.rounded-lg`）。
 * 2. **@shared/ui-system**：Tailwind preflight + `@theme` design token 定義。
 * 3. **@shared/fonts**：`@font-face` 宣告，順序不敏感。
 */

import '@mobile/theme';
import '@shared/ui-system';
import '@shared/fonts';

import { setupIonicReact } from '@ionic/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerServiceWorker } from '@shared/pwa';
import { App } from './app';

/*
 * 不指定 mode，讓 Ionic 依執行平台自動選擇 iOS 或 Material Design 的互動慣例
 * （轉場方向、回彈曲線、控制項外觀）。「貼近原生」的前提就是跟隨所在平台，
 * 硬鎖成單一 mode 會讓其中一個平台的使用者覺得哪裡不對勁。
 */
setupIonicReact();

/*
 * 註冊 Service Worker。dev server 不產生 sw.js，且快取會干擾熱更新，故僅在
 * production build 啟用。
 */
registerServiceWorker({ disabled: !import.meta.env.PROD });

const container = document.getElementById('root');

if (!container) {
  throw new Error('找不到 #root 掛載點，請確認 index.html 未被更動。');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
